// Module-level mirror of the current org/workspace (set by TenantProvider)
// so plain async helpers — createEntity, the hand-written createItem — can
// stamp orgId/workspaceId on new docs without hooks. Kept in its own module
// to avoid an entities.js ↔ firestore.js import cycle.
let currentTenant = { orgId: null, workspaceId: null };
export const setCurrentTenant = (orgId, workspaceId) => {
  currentTenant = { orgId: orgId || null, workspaceId: workspaceId || null };
};
export const getCurrentTenant = () => currentTenant;
// Always both fields: the rules read them directly, so a doc lacking them is
// unreadable. null orgId = legacy open doc (any signed-in user).
export const tenantStamp = () => ({ orgId: currentTenant.orgId || null, workspaceId: currentTenant.orgId ? currentTenant.workspaceId || null : null });
